import { render } from "./RequestStep.vue?vue&type=template&id=fc2aa880&scoped=true&ts=true"
import script from "./RequestStep.vue?vue&type=script&lang=ts"
export * from "./RequestStep.vue?vue&type=script&lang=ts"

import "./RequestStep.vue?vue&type=style&index=0&id=fc2aa880&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc2aa880"]])

export default __exports__